import { useEffect, useState } from 'react';
import { getDocumentApi } from './utils';


export const useLoadScript = (url?: string) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!url) return;
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => {
      setLoaded(true);
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
  return loaded;
};

export const useONLYOFFICE = (url?: string) => {
  const [docsAPI, setDocsAPI] = useState<any>();
  const isLoaded = useLoadScript(getDocumentApi(url));

  useEffect(() => {
    if (!isLoaded) return;
    if (window.DocsAPI !== undefined) {
      setDocsAPI(window.DocsAPI);
    }
  }, [isLoaded]);
  return { docsAPI, isLoaded };
};
